<div mat-dialog-title id="skip-subscription">Skip Subscription
  <div class="dialog-close-button">
    <a (click)="onClose()" id="close">
      <img src="/assets/images/close-popup.png">
    </a>
  </div>
</div>
<form>
  <div mat-dialog-content cdkFocusInitial>
    <p id="next-delivery-date">Skip your {{date | date:'longDate'}} delivery on</p>
    <div *ngFor="let item of itemDetails;let i = index" id="itemId-{{i+1}}">{{item.itemId}}, {{item.description}}</div>
    <br />
    <p id="skip-date">Your next delivery will arrive by:<br />
      {{updateDate | date:'longDate'}}</p>
  </div>
  <div mat-dialog-actions>
    <button mat-raised-button [mat-dialog-close]="false" id="skip-btn-close" class="cancel">Cancel</button>
    <button mat-raised-button [mat-dialog-close]="true" id="skip-btn-confirm" class="confirm">Confirm</button>
  </div>

</form>